module.exports = __webpack_public_path__ + "img/27_BF5_cry_wolf.e32e85e6.jpg";